
(() => {
  const SELECTORS = {
    sections: [
      '.p2c-about-story',
      '.p2c-about-beliefs-luxe',
      '.p2c-about-craft-luxe',
      '.p2c-about-moments-luxe',
      '.p2c-about-community-luxe'
    ],
    headings: [
      '[class*="__eyebrow"]',
      '[class*="__heading"]',
      '[class*="__intro"]',
      '[class*="__body"]',
      '[class*="__signature"]',
      '[class*="__button"]',
      '[class*="__note"]'
    ],
    cards: [
      '.p2c-about-beliefs-luxe__card',
      '.p2c-about-craft-luxe__card',
      '.p2c-about-moments-luxe__card',
      '.p2c-about-community-luxe__card'
    ],
    parallax: []
  };

  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  function init() {
    const loader = document.querySelector('[data-p2c-about-motion]');
    if (!loader) return;

    const revealEnabled = loader.dataset.enableReveal === 'true';
    const parallaxEnabled = loader.dataset.enableParallax === 'true';
    const hoverEnabled = loader.dataset.enableHover === 'true';
    const watermarksEnabled = loader.dataset.enableWatermarks === 'true';
    const strength = Math.max(1, Math.min(5, Number(loader.dataset.motionStrength || 2)));

    document.documentElement.classList.add('p2c-motion-ready');
    document.body.classList.toggle('p2c-motion-hover', hoverEnabled);
    document.body.classList.toggle('p2c-motion-watermarks', watermarksEnabled);

    const sections = SELECTORS.sections.flatMap((s) => qsa(s));

    sections.forEach((section, sectionIndex) => {
      if (watermarksEnabled && !section.hasAttribute('data-p2c-section-number')) {
        section.setAttribute('data-p2c-section-number', String(sectionIndex + 1).padStart(2, '0'));
      }

      if (!revealEnabled) return;

      const headingParts = SELECTORS.headings.flatMap((s) => qsa(s, section));
      headingParts.forEach((el, index) => {
        if (!el.hasAttribute('data-p2c-reveal')) {
          el.setAttribute('data-p2c-reveal', 'text');
          el.style.setProperty('--p2c-delay', `${Math.min(index, 5) * 90}ms`);
        }
      });

      const cards = SELECTORS.cards.flatMap((s) => qsa(s, section));
      cards.forEach((card, index) => {
        card.setAttribute('data-p2c-reveal', 'card');
        card.style.setProperty('--p2c-delay', `${index * 120}ms`);
      });

      const media = qsa('[class*="__media"], [class*="__media-wrap"]', section);
      media.slice(0, 2).forEach((el, index) => {
        if (!el.hasAttribute('data-p2c-reveal')) {
          el.setAttribute('data-p2c-reveal', 'image');
          el.style.setProperty('--p2c-delay', `${120 + index * 80}ms`);
        }
      });
    });

    if (revealEnabled) {
      const revealEls = qsa('[data-p2c-reveal]');
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.08
      });

      revealEls.forEach((el) => observer.observe(el));
    }

    if (parallaxEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const targets = SELECTORS.parallax.flatMap((s) => qsa(s));
      targets.forEach((el) => el.setAttribute('data-p2c-parallax', ''));

      let ticking = false;
      const updateParallax = () => {
        ticking = false;
        const viewportH = window.innerHeight;

        targets.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > viewportH) return;

          const center = rect.top + rect.height / 2;
          const progress = (center - viewportH / 2) / viewportH;
          const amount = -progress * (6 + strength * 2);
          el.style.setProperty('--p2c-parallax-y', `${amount.toFixed(2)}px`);
        });
      };

      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateParallax);
      }, { passive: true });

      window.addEventListener('resize', updateParallax, { passive: true });
      updateParallax();
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
